import { axiosInstance } from '../lib/axios'
import { normalizeCNPJ } from '../utils/cnpjUtils'

export const getVoucherCount = async (cnpj) => {
  try {
    const cleanCnpj = normalizeCNPJ(cnpj)
    const response = await axiosInstance.get(
      `/voucher/consumed/${encodeURIComponent(cleanCnpj)}`
    )
    return Number(response.data.count || 0)
  } catch (err) {
    console.error('Erro ao buscar contagem de vouchers:', err)
    throw err
  }
}

export const registerVoucher = async ({ voucherCode, cnpj }) => {
  try {
    const response = await axiosInstance.post('/voucher/consume', {
      voucherCode,
      cnpj: normalizeCNPJ(cnpj)
    })

    return response.data
  } catch (err) {
    console.error('Erro ao consumir voucher:', err)
    throw err.response?.data || { success: false, message: 'Erro desconhecido' }
  }
}
